















































import { Component, Vue } from 'vue-property-decorator'
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import WorkerLocationCreate from '@/components/Workers/WorkerLocationCreate.vue'
import { VuetifyConfirmObject } from 'vuetify-confirm';
import LocationWorkerDto from '@/models/LocationWorkers/LocationWorkerDto';
import LocationWorkerType from '@/components/Locations/Display/LocationWorkerType.vue';
import DeleteLocationWorkerRequest from '@/models/LocationWorkers/DeleteLocationWorkerRequest';
import WorkerLocationEdit from '@/components/Workers/WorkerLocationEdit.vue';
import { AppModule } from '@/store/modules/app';

@Component({
    name: 'WorkerLocationsList',
    components: { WorkerLocationCreate, LocationWorkerType, WorkerLocationEdit
    }
})
export default class extends GiganautVue {

    async navigateToLocation(item: LocationWorkerDto) {
        this.$router.push({ name: PageNames.AgencyLocationDetails, params: { locationid: item.locationId } });
    }

    get workerLocations(): LocationWorkerDto[] {
        return WorkerDetailsModule.locationWorkers;
    }

    get loading() {
        return WorkerDetailsModule.loadingLocationWorkers;
    }

    async created() {
        await this.getLocations();
    }

    private async getLocations() {
        await WorkerDetailsModule.getLocationWorkers();
    }

    async deleteWorkerLocation(locationWorker: LocationWorkerDto) {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "DELETE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this association?', options);
        if (result) {
            const request = new DeleteLocationWorkerRequest();
            request.locationId = locationWorker.locationId;
            request.locationWorkerId = locationWorker.id;
            await WorkerDetailsModule.deleteLocationWorker(request);
        }
    }

    private search = '';
    
    private headers = [
    { text: 'Brand Name', value: 'location.brandName' },
    { text: 'Address' },
    { text: 'Link Type'},
    { text: 'Actions'},
    ]
}
